var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode",on:{"click":_vm.goLink}},[_c('img',{attrs:{"src":require("@/assets/img-qrcode.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }